/**
 * FAQ лендинга — единый источник текстов.
 */
import {
  EDUCATOR_SUBSCRIPTION_FROM_LABEL,
  REFUND_LINE_SHORT,
  CANCEL_ANYTIME,
  PLAN_LIMITS_COPY,
} from '@/lib/siteCopy';

export const FAQ_CATEGORIES = [
  { id: 'all', label: 'Все' },
  { id: 'start', label: 'Оплата' },
  { id: 'practice', label: 'Режимы' },
  { id: 'tutors', label: 'Наставникам' },
];

/**
 * @param {{ priceLabel: string }} opts
 */
export function buildLandingFaqItems({ priceLabel }) {
  const plus = PLAN_LIMITS_COPY.plus;
  const max = PLAN_LIMITS_COPY.max;
  return [
    {
      id: 'limits',
      category: 'start',
      icon: 'Zap',
      question: 'Как работают лимиты тарифа?',
      answer: `Тестовые задания на «Старт» — без ограничений. «Плюс» (${priceLabel}): ${plus.written} письменных проверок, ${plus.mock} пробника, ${plus.explanations} разборов в месяц. «Максимум»: ${max.written} письменных, ${max.mock} пробников. Проверка уже отправленных ответов — без доплат. Ученик у наставника получает лимиты по тарифу репетитора.`,
    },
    {
      id: 'refund',
      category: 'start',
      icon: 'Shield',
      question: 'Если не зайдёт — вернёте деньги?',
      answer: `${REFUND_LINE_SHORT}. ${CANCEL_ANYTIME} в личном кабинете. Если лимиты оплаченного периода уже использованы, за них возврат не делаем. Подробности — на странице «Возврат средств».`,
    },
    {
      id: 'probnik-marathon',
      category: 'practice',
      icon: 'FileText',
      question: 'Пробник или марафон — что выбрать?',
      answer:
        'Пробник — полный вариант как на экзамене: все номера, официальный таймер, можно заменить задание. Марафон — только выбранные номера или проблемные за период. Оба режима учитываются в лимите пробников тарифа.',
    },
    {
      id: 'check-wait',
      category: 'practice',
      icon: 'FileCheck',
      question: 'Платить за каждую проверку ответа?',
      answer:
        'Нет. Лимит тратится при создании пробника или марафона с письменными заданиями. Перепроверка и разбор в той же сессии — бесплатно.',
    },
    {
      id: 'educator-tariff',
      category: 'tutors',
      icon: 'GraduationCap',
      question: 'Тариф для репетитора или школы?',
      answer: `Вы платите за класс — ученики получают «Плюс» или «Максимум» без отдельной оплаты. Тарифы от ${EDUCATOR_SUBSCRIPTION_FROM_LABEL} в кабинете наставника. CRM, домашка, материалы и расписание включены.`,
    },
  ];
}

export function faqAnswerPlainText(answer) {
  return String(answer || '').replace(/\s+/g, ' ').trim();
}
